import Api from "./Api";
import { API_VERSION } from "@/config/index";
import { createQueryString } from './ApiHelper';

export default {
  GetTransactions(payload) {
    const query = createQueryString(payload);
    console.log(query, "JJJJJJJJJJJJJJJJJDFLDFJDLFDSFDSLF")
    return Api().get(`/admin/transaction/${query}`, payload);
  },
    GetDailyFailedTransactions() {
    return Api().get(`/admin/dailyFailedTransaction`);
  },
    GetWeeklyTransactions() {
    return Api().get(`/admin/weeklyRefundedTransaction`);
  },
  GetTransaction(payload) {
    return Api().get(`/admin/transaction/${payload.transaction_id}`, payload);
  },
  GetPayments(payload) {
    const query = createQueryString(payload);
    return Api().get(`/admin/payments/${query}`);
  },
  GetTransactionsStats(payload) {
    const query = createQueryString(payload);
    return Api().get(`/admin/transactions-stats/${query}`);
  },
  GetSpacificTransaction(payload) {
    return Api().get(`/admin/transaction/${payload.transaction_id}`);
  },
};
